import { hasLenderFinancing, hasBeenRejectedByAllLenders, getConfigForService } from '../../utils/util_funcs.js';
import { LeadSourceType, LeadType, LeadStageType } from '../leads/Lead.js';
import { Services } from '../servicesProviders/services/Services.js';
import '../servicesProviders/services/ServicesProviderAssemblyData.js';
import '../servicesProviders/services/ServicesProviderCoverageFulfillmentData.js';
import '../servicesProviders/services/ServicesProviderCoveragePlatformData.js';
import '../servicesProviders/services/ServicesProviderCoverageTaxData.js';
import '../servicesProviders/services/ServicesProviderCoverageVendorData.js';
import '../servicesProviders/services/ServicesProviderDeliveryData.js';
import '../servicesProviders/services/ServicesProviderDomainsData.js';
import '../servicesProviders/services/ServicesProviderExternalFeesData.js';
import '../servicesProviders/services/ServicesProviderExternalTaxData.js';
import '../servicesProviders/services/ServicesProviderFinancingBrokerageData.js';
import '../servicesProviders/services/ServicesProviderFinancingBrokeragePlatformData.js';
import '../servicesProviders/services/ServicesProviderFinancingData.js';
import '../servicesProviders/services/ServicesProviderFreightData.js';
import '../servicesProviders/services/ServicesProviderInspectionData.js';
import '../servicesProviders/services/ServicesProviderInternalFeesData.js';
import '../servicesProviders/services/ServicesProviderInventoryData.js';
import '../servicesProviders/services/ServicesProviderLicensureData.js';
import '../servicesProviders/services/ServicesProviderOriginatorData.js';
import '../servicesProviders/services/ServicesProviderPayableData.js';
import '../servicesProviders/services/ServicesProviderPickupData.js';
import '../servicesProviders/services/ServicesProviderPlatformData.js';
import '../servicesProviders/services/ServicesProviderProcessingFeesData.js';
import '../servicesProviders/services/ServicesProviderProgramOwnerData.js';
import '../servicesProviders/services/ServicesProviderRegistrationData.js';
import '../servicesProviders/services/ServicesProviderSaleData.js';
import '../servicesProviders/services/ServicesProviderTariffData.js';
import '../servicesProviders/services/ServicesProviderTempTagData.js';
import '../servicesProviders/services/ServicesProviderTitlingData.js';
import '../servicesProviders/services/ServicesProviderAssembly.js';
import '../servicesProviders/services/ServicesProviderCoverageFulfillment.js';
import '../servicesProviders/services/ServicesProviderCoveragePlatform.js';
import '../servicesProviders/services/ServicesProviderCoverageTax.js';
import '../servicesProviders/services/ServicesProviderCoverageVendor.js';
import '../servicesProviders/services/ServicesProviderDelivery.js';
import '../servicesProviders/services/ServicesProviderDomains.js';
import '../servicesProviders/services/ServicesProviderExternalFees.js';
import '../servicesProviders/services/ServicesProviderExternalTax.js';
import '../servicesProviders/services/ServicesProviderFinancing.js';
import '../servicesProviders/services/ServicesProviderFinancingBrokerage.js';
import '../servicesProviders/services/ServicesProviderFinancingBrokeragePlatform.js';
import '../servicesProviders/services/ServicesProviderFinancingBrokerageSubvention.js';
import '../servicesProviders/services/ServicesProviderFreight.js';
import '../servicesProviders/services/ServicesProviderInspection.js';
import '../servicesProviders/services/ServicesProviderInternalFees.js';
import '../servicesProviders/services/ServicesProviderInventory.js';
import '../servicesProviders/services/ServicesProviderLicensure.js';
import '../servicesProviders/services/ServicesProviderOriginator.js';
import '../servicesProviders/services/ServicesProviderPayable.js';
import '../servicesProviders/services/ServicesProviderPickup.js';
import '../servicesProviders/services/ServicesProviderPlatform.js';
import '../servicesProviders/services/ServicesProviderProcessingFees.js';
import '../servicesProviders/services/ServicesProviderProgramOwner.js';
import '../servicesProviders/services/ServicesProviderRegistration.js';
import '../servicesProviders/services/ServicesProviderSale.js';
import '../servicesProviders/services/ServicesProviderTariff.js';
import '../servicesProviders/services/ServicesProviderTempTag.js';
import '../servicesProviders/services/ServicesProviderTitling.js';

const VehicleStage = {
    SIGN_OFF: 'signOff',
    PENDING_PAYMENT_GUARANTEE: 'pendingPaymentGuarantee',
    PENDING_VERIFICATION: 'pendingVerification',
    PRODUCTION: 'production',
    COMPLETE: 'complete',
};
const IdDocumentType = {
    DRIVING_LICENSE: 'driving_license',
    PASSPORT: 'passport',
    ID_CARD: 'id_card',
};
// TAR Automation status
const TarAutomationStatus = {
    STARTED: 'STARTED',
    COMPLETED: 'COMPLETED',
    FAILED_AND_RESET: 'FAILED_AND_RESET',
    FAILED_WITHOUT_RESET: 'FAILED_WITHOUT_RESET',
};
const VehicleExternalStatus = {
    UNCATEGORIZED: 'UNCATEGORIZED',
    PREORDER: 'PREORDER',
    CANCELED: 'CANCELED',
    ON_HOLD: 'ON_HOLD',
    PENDING: 'PENDING',
    AWAITING_OEM_ACTION: 'AWAITING_OEM_ACTION',
    AWAITING_BUYER_OR_EKHO_ACTION: 'AWAITING_BUYER_OR_EKHO_ACTION',
    KICK_OFF_FULFILLMENT: 'KICK_OFF_FULFILLMENT',
    FULFILLMENT_IN_PROGRESS: 'FULFILLMENT_IN_PROGRESS',
    FULFILLED: 'FULFILLED',
};
const VehicleFulfillmentStatus = {
    UNFULFILLED: 'UNFULFILLED',
    FULFILLED: 'FULFILLED',
    READY_TO_FULFILL: 'READY_TO_FULFILL',
    CANCELED: 'CANCELED',
    ON_HOLD: 'ON_HOLD',
    IN_TRANSIT_TO_BUYER: 'IN_TRANSIT_TO_BUYER',
    IN_TRANSIT_TO_FULFILLMENT_CENTER: 'IN_TRANSIT_TO_FULFILLMENT_CENTER',
    RECEIVED_AT_FULFILLMENT_CENTER: 'RECEIVED_AT_FULFILLMENT_CENTER',
    PICKUP_SCHEDULED: 'PICKUP_SCHEDULED',
    READY_TO_DISPATCH: 'READY_TO_DISPATCH',
};
function formatFulfillmentStatus(status) {
    if (!status) {
        return '';
    }
    switch (status) {
        case VehicleFulfillmentStatus.UNFULFILLED:
            return 'Unfulfilled';
        case VehicleFulfillmentStatus.FULFILLED:
            return 'Fulfilled';
        case VehicleFulfillmentStatus.READY_TO_FULFILL:
            return 'Ready to fulfill';
        case VehicleFulfillmentStatus.CANCELED:
            return 'Canceled';
        case VehicleFulfillmentStatus.ON_HOLD:
            return 'On hold';
        case VehicleFulfillmentStatus.IN_TRANSIT_TO_BUYER:
            return 'In transit to buyer';
        case VehicleFulfillmentStatus.IN_TRANSIT_TO_FULFILLMENT_CENTER:
            return 'In transit to fulfillment center';
        case VehicleFulfillmentStatus.RECEIVED_AT_FULFILLMENT_CENTER:
            return 'Received at fulfillment center';
        case VehicleFulfillmentStatus.PICKUP_SCHEDULED:
            return 'Pickup scheduled';
        case VehicleFulfillmentStatus.READY_TO_DISPATCH:
            return 'Ready to dispatch';
        default:
            return String(status)
                .split('_')
                .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                .join(' ');
    }
}
const VehiclePaymentSelection = {
    NATIVE_FINANCING: 'nativeFinancing',
    OTHER_FINANCING: 'otherFinancing',
    CHECKOUT_FULL_PAYMENT: 'checkoutFullPayment',
    CASH_EARLY: 'cashEarly',
    CASH: 'cash',
    KLARNA_CHECKOUT_FULL_PAYMENT: 'klarnaCheckoutFullPayment',
    CRYPTO_CHECKOUT_FULL_PAYMENT: 'cryptoCheckoutFullPayment',
};
const VehiclePaymentStatus = {
    NO_PAYMENTS: 'NO_PAYMENTS',
    RESERVATION_PAID: 'RESERVATION_PAID',
    RESERVATION_INITIATED: 'RESERVATION_INITIATED',
    FINANCING_GUARANTEED: 'FINANCING_GUARANTEED',
    FULLY_PAID: 'FULLY_PAID',
    DOWNPAYMENT_PAID: 'DOWNPAYMENT_PAID',
    LOST_DISPUTE: 'LOST_DISPUTE',
};
function formatPaymentStatus(status) {
    if (!status) {
        return '';
    }
    switch (status) {
        case VehiclePaymentStatus.FULLY_PAID:
            return 'Fully paid';
        case VehiclePaymentStatus.DOWNPAYMENT_PAID:
            return 'Downpayment paid';
        case VehiclePaymentStatus.NO_PAYMENTS:
            return 'No payments';
        case VehiclePaymentStatus.RESERVATION_PAID:
            return 'Reservation paid';
        case VehiclePaymentStatus.RESERVATION_INITIATED:
            return 'Reservation initiated';
        case VehiclePaymentStatus.FINANCING_GUARANTEED:
            return 'Financing guaranteed';
        case VehiclePaymentStatus.LOST_DISPUTE:
            return 'Lost dispute';
        default:
            return String(status)
                .split('_')
                .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                .join(' ');
    }
}
const PurchasedVehicleFinancingOfferStatus = {
    AWAITING_LENDER_DECISIONS: 'AWAITING_LENDER_DECISIONS',
    SOME_LENDERS_ACCEPTED: 'SOME_LENDERS_ACCEPTED',
    ALL_LENDERS_REJECTED: 'ALL_LENDERS_REJECTED',
    BUYER_ACCEPTED_SOME_OFFER: 'BUYER_ACCEPTED_SOME_OFFER',
    BUYER_REJECTED_ALL_OFFERS: 'BUYER_REJECTED_ALL_OFFERS',
    PAUSED: 'PAUSED',
};
function formatFinancingOfferStatus(status) {
    if (!status) {
        return '';
    }
    switch (status) {
        case PurchasedVehicleFinancingOfferStatus.AWAITING_LENDER_DECISIONS:
            return 'Awaiting lender decisions';
        case PurchasedVehicleFinancingOfferStatus.SOME_LENDERS_ACCEPTED:
            return 'Some lenders accepted';
        case PurchasedVehicleFinancingOfferStatus.ALL_LENDERS_REJECTED:
            return 'All lenders rejected';
        case PurchasedVehicleFinancingOfferStatus.BUYER_ACCEPTED_SOME_OFFER:
            return 'Buyer accepted an offer';
        case PurchasedVehicleFinancingOfferStatus.BUYER_REJECTED_ALL_OFFERS:
            return 'Buyer rejected all offers';
        case PurchasedVehicleFinancingOfferStatus.PAUSED:
            return 'Paused';
        default:
            return String(status)
                .split('_')
                .map((word) => word.charAt(0) + word.slice(1).toLowerCase())
                .join(' ');
    }
}
const TypeOfOrder = {
    PREORDER: 'preorder',
    BUILD_TO_ORDER: 'buildToOrder',
    INVENTORY_ORDER: 'inventoryOrder',
};
/**
 * PurchasedVehicleEntity - Entity class that implements ILeadSource
 * Uses the PurchasedVehicle interface structure with ILeadSource capabilities
 */
class PurchasedVehicleEntity {
    constructor(data) {
        // Simple, clean assignment - let Object.assign handle everything
        Object.assign(this, data);
        // Runtime validation of required properties
        this.validateRequiredProperties();
        // Initialize ILeadSource properties
        this.sourceType = this.getSourceType();
        this.sourceId = this.getId();
        this.sourceMetadata = this.extractSourceMetadata();
    }
    validateRequiredProperties() {
        const requiredProps = [
            'id',
            'productId',
            'buyerId',
            'buyerFullName',
            'placedOrderId',
            'orderFee',
            'name',
            'basePrice',
            'imgUrl',
            'oemId',
            'typeOfOrder',
            'datePurchased',
            'stage',
            'vehicleFulfillmentStatus',
            'paymentInfo',
            'externalStatus',
            'registrationDetails',
        ];
        for (const prop of requiredProps) {
            if (this[prop] === undefined) {
                throw new Error(`Required property '${prop}' is missing from PurchasedVehicle data`);
            }
        }
    }
    // =====================================
    // ILEADSOURCE IMPLEMENTATION
    // =====================================
    // Checks if the purchased vehicle is financing and has been rejected by all lenders.
    shouldCreateLead() {
        const pv = this;
        return hasLenderFinancing(pv) && hasBeenRejectedByAllLenders(pv);
    }
    extractSourceMetadata() {
        // Extract: datePurchased, totalPrice, vehicle name, cancellation reason
        return {
            dateCreated: this.datePurchased,
            cartValue: this.totalPrice,
            vehicleName: this.name,
            status: this.cancelationAgent || 'ACTIVE',
        };
    }
    extractLeadData(buyer, programOwner) {
        // Extract buyer information
        // Get vehicle and OEM information
        // Set financing rejection pipeline
        return {
            email: buyer?.email,
            phoneNumber: buyer?.phone,
            fullName: this.buyerFullName,
            cartTotal: this.totalPrice,
            vehicleName: this.name,
            models: this.extractVehicleModels(),
            programOwnerId: programOwner.id,
            buyerId: this.buyerId,
            type: this.getLeadType(),
            svpId: this.getSvpId(programOwner),
            actionItemSummary: this.actionItemSummary,
        };
    }
    getSourceType() {
        return LeadSourceType.PURCHASED_VEHICLE;
    }
    getLeadType() {
        return LeadType.REJECTED_FINANCING;
    }
    getSvpId(programOwner) {
        if (getConfigForService(programOwner, Services.PROGRAM_OWNER)?.checkout?.assignment?.dynamic) {
            return this.servicesProviders?.[Services.SALE];
        }
        return programOwner.id;
    }
    extractIdentifierComponents(buyer, programOwner) {
        return {
            email: buyer.email,
            svpId: this.getSvpId(programOwner),
        };
    }
    extractVehicleModels() {
        // Extract vehicle model name from purchased vehicle
        return this.name ? [this.name] : [];
    }
    extractVehicleInformation() {
        return [
            {
                name: this.name,
                year: this.year?.toString() ?? '',
                make: '',
                model: this.name,
                advertisedPrice: this.totalPrice ?? this.basePriceWithSpecs ?? this.basePrice ?? 0,
                vin: this.vin,
            },
        ];
    }
    getBuyerId() {
        // PurchasedVehicle already has buyerId field
        return this.buyerId;
    }
    getId() {
        return this.id;
    }
    getUniqueSourceIdentifier() {
        return `${this.getSourceType()}|${this.getId()}`;
    }
    calculateLeadStage(previousDocument) {
        const pv = this;
        // Check if vehicle was rejected by all lenders (transition from false to true)
        if (hasBeenRejectedByAllLenders(pv) &&
            previousDocument &&
            !hasBeenRejectedByAllLenders(previousDocument)) {
            return {
                newStage: LeadStageType.TO_REACH_OUT,
                reason: 'Purchased vehicle was rejected by all lenders and requires follow-up',
                source: 'PURCHASED_VEHICLE_FINANCING_REJECTED',
            };
        }
        // Check if payment status changed to FULLY_PAID (transition from non-FULLY_PAID to FULLY_PAID)
        if (this.paymentInfo.vehiclePaymentStatus === VehiclePaymentStatus.FULLY_PAID &&
            previousDocument?.paymentInfo.vehiclePaymentStatus !== VehiclePaymentStatus.FULLY_PAID) {
            return {
                newStage: LeadStageType.CLOSED_WON,
                reason: 'Buyer paid in full with cash after financing rejection',
                source: 'PURCHASED_VEHICLE_FULLY_PAID',
            };
        }
        return null;
    }
    sourceToJson() {
        return {
            sourceType: this.sourceType,
            sourceId: this.sourceId,
            sourceMetadata: this.sourceMetadata,
        };
    }
    shouldTriggerADFNotificationOnCreate() {
        return true;
    }
    static getCollectionInfo() {
        return {
            collectionName: 'PurchasedVehicles',
            isCollectionGroup: true,
        };
    }
}

export { IdDocumentType, PurchasedVehicleEntity, PurchasedVehicleFinancingOfferStatus, TarAutomationStatus, TypeOfOrder, VehicleExternalStatus, VehicleFulfillmentStatus, VehiclePaymentSelection, VehiclePaymentStatus, VehicleStage, formatFinancingOfferStatus, formatFulfillmentStatus, formatPaymentStatus };
//# sourceMappingURL=PurchasedVehicle.js.map
